import React from 'react';
import { DataGridButton, IColumnType, IDataType, SisDataGridColumns } from '../../components/table';

export const Columns = (handleEdit, handleDelete, translate): SisDataGridColumns => [
  {
    dataType: IDataType.string,
    dataField: 'ip',
    width: '8%',
    caption: 'Ip address',
  },
  {
    dataType: IDataType.string,
    dataField: 'defaultAssetClassNameTranslated',
    width: '10%',
    caption: 'Asset class',
  },
  {
    dataType: IDataType.string,
    dataField: 'assetName',
    width: '10%',
    caption: 'Default asset name',
  },
  {
    dataType: IDataType.string,
    dataField: 'defaultUserName',
    width: '15%',
    caption: 'Default user',
  },
  {
    dataType: IDataType.string,
    dataField: 'description',
    width: '49%',
    caption: 'Description',
  },
  {
    type: IColumnType.buttons,
    cellRender: (data) => ButtonCell(data, handleEdit, handleDelete, translate),
    width: '8%',
  },
];

const ButtonCell = (cellData, handleEdit, handleDelete, translate) => {
  return (
    <>
      <DataGridButton
        hint={translate!('Edit', '')}
        icon="edit"
        cellData={cellData}
        onClick={() => handleEdit(cellData)}
        marginRight
      />
      <DataGridButton
        hint={translate!('Delete', '')}
        icon="trash"
        cellData={cellData}
        onClick={() => handleDelete(cellData)}
      />
    </>
  );
};
